function setStoreData(state, params) {
  const { key, type, data, commitInfo, identifierName } = params;
  if (!key) {
    throw new Error(`The key can't be empty`);
  }
  if (data === undefined || data === null) {
    throw new Error(`The data can't be empty`);
  }
  if (!identifierName) {
    throw new Error(`Must be have identifierName for convenient debug`);
  } else {
    console.log(`%c` + `The commit from ${identifierName}.vue/.js, commit key name is ${key}`, `color: #e3e`);
    if (commitInfo) {
      console.log(`The commit info: ` + commitInfo);
    }
  }
  state[key] = JSON.parse(JSON.stringify(data));
}

export default setStoreData;
